import React from 'react'

const HorizontleButtons = ({ scrollRight, scrollLeft, type, className }) => {
    return (
        <div className={`sm:hidden flex items-center justify-end w-full gap-4 ${className}`}>
            <div className='size-9'>
                <img
                    onClick={scrollLeft}
                    className='w-full'
                    src={
                        type === "blue"
                            ? require('../../assets/leftDirBtnBlue.png')
                            : require('../../assets/leftDirBtn.png')
                    }
                />
            </div>
            <div className='size-9'>
                <img
                    onClick={scrollRight}
                    className='w-full'
                    src={
                        type === "blue"
                            ? require('../../assets/rightDirBtnBlue.png')
                            : require('../../assets/rightDirBtn.png')
                    }
                />
            </div>
        </div>
    )
}

export default HorizontleButtons
